<template>
	<div
		class="d-none d-md-block"
		:class="{
			[$style.footer]: true,
			[$style.footerFullWidth]: $settings.isContentNoMaxWidth,
		}"
	>
		<div :class="$style.inner">
			<div class="row align-items-center">
				<div
					class="col-md-12 col-lg-8 d-flex flex-row align-items-center"
				>
					<g-logo :text="false" class="mr-2" :size="80" />
					<div>
						<p class="font-size-12 mb-2 text-justify">
							💁 Organiza, analiza y mejora la gestión de tus
							datos y empresa. GestiOS da soporte al alojamiento,
							tratamiento y análisis de datos en cualquier tipo de
							aplicativo. Desarrollado bajo la premisa de ser
							completamente modular, te permite disponer de tus
							apps a medida, con unas condiciones económicas
							inmejorables. 👌
						</p>
						<p class="font-size-12 mb-0">
							&copy; {{ $moment().format("YYYY") }} GestiOS. Todos
							los derechos reservados.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
